import React from 'react';
import Axios from 'axios';
import moment from 'moment';

import * as myConstClass from '../../shared/constants/constants';

const DASHMOD_NBOF_DATACOL = 7;

class DashMod_FriendsZone01 extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			playerId: 0,
			resultsType: '',
			leagueType: '',

			resultTableData: [],
			sortFieldIdx: 0,
			sortOrder: 'desc',	// date desc by default
			loading: true
		};
	
		this.createTableRow = this.createTableRow.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	getInitialState() {
		return {
			playerId: 0,
			resultsType: '',
			leagueType: '',

			resultTableData: [],
			sortFieldIdx: 0,
			sortOrder: 'desc',	// date desc by default
			loading: true
		}
	}

	componentDidMount() {
    console.log('DashMod_FriendsZone01: componentDidMount');
    this.setState({loading: true});
    this.loadData();
	}

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log('DashMod_FriendsZone01: UNSAFE_componentWillReceiveProps');
    this.setState({loading: true});
    this.loadData();
  }

	loadData() {
		console.log('DashMod_FriendsZone01 - loadData');
		var _this = this;
		document.body.classList.add('busy-cursor');
/*
		Axios.get('/api/friendzone01/getFriends/playerId/' + this.state.playerId + 
			'/resultsType/' + this.state.resultsType + '/leagueType/' + this.state.leagueType).
*/
		Axios.get('/api/friendzone01/getFriends/playerId/' + this.state.playerId).
			then(function(response) {
				console.log('getFriends');
				//console.log(response.data);
				document.body.classList.remove('busy-cursor');
		});	
	}

	render() {
		console.log('DashMod_FriendsZone01: render');
		var bDispModule = true;
		return (
			<div className="row">
			<div className="col-md-12">
			<div className="card">
				<div className="card-header">
					<i className="fa fa-user"></i>
       		<span className="text-uppercase font-weight-bold">Friends Zone</span>
				</div>

				<div className="card-block card-body">
					{bDispModule ? this.displayModule() : 
						<div>
						<p>Aucune partie jouée</p>
						</div>
					}
				</div>
			</div>
			</div>
			</div>
		)
	}

	displayModule() {
		if (this.state.loading) {
			return ( this.displaySpinner() );
		} else {
			return ( this.displayData() );
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	displayData() {
		return (
			<div>
			<p>text</p>
			
			<div className="table-responsive">
			<table className="table table-striped table-hover table-sm">
			<thead>
				<tr>
				<th id="colid.0" className="statelo-sorting" onClick={this.handleSortTable}> Date </th>
				<th id="colid.1" className="statelo-sorting" onClick={this.handleSortTable}> Joueur(s) </th>
				<th id="colid.2" className="statelo-sorting" onClick={this.handleSortTable}> Adversaire(s) </th>
				<th id="colid.3" className="statelo-sorting" onClick={this.handleSortTable}> Pointage </th>
				<th id="colid.4" className="statelo-sorting" onClick={this.handleSortTable}> Stats </th>
				<th id="colid.5" className="statelo-sorting" onClick={this.handleSortTable}> Saison </th>
				</tr>
			</thead>

			<tbody>
				{this.state.resultTableData.map(this.createTableRow)}
			</tbody>
			</table>
			</div>
			</div>
		);
	}

	createTableRow(item, idx) {
		return (
			<tr key={'te.' + idx}>
				<td>0</td>
				<td>0</td>
				<td>0</td>
				<td>0</td>
				<td>0</td>
				<td>0</td>
      </tr>
    );
	}

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {
		var _this = this;
		var colIdx = parseInt(e.target.id.split(".")[1], 10);
		var results = this.state.resultTableData;
		var sortOrder = this.state.sortOrder;
		var sortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (sortFieldIdx === colIdx) {
			if (sortOrder === 'desc') {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		} else {
			if (colIdx === 2) {
				sortOrder = 'asc';
			} else {
				sortOrder = 'desc';
			}
		}

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: colIdx,
		});

    this.loadData(colIdx, sortOrder);
	}

}

export default DashMod_FriendsZone01;
